export enum SurveyValidationResult {
    OK,
    MISSING_TARGET,
    SURVEY_STRUCTURE_INVALID,
    TRANSLATION_MISSING,
    UNKNOWN = 7,
}

export enum SurveyStatus {
  PENDING ,
  LIVE,
  ENDED,
  PAUSED,
  SCHEDULED,
}


export enum TargetType {
  ATP = 1,
  MOA = 2,
}
